import './Services.css';
import logo2 from '../assets/logo2.png';

const Services = () => {
  const services = [
    {
      title: "Custom Software Development",
      description: "End-to-end software solutions tailored to your unique business challenges and goals",
      features: ["Web Applications", "Mobile Apps", "Desktop Software", "API Development", "Database Design"],
      icon: "💻"
    },
    {
      title: "Digital Transformation",
      description: "Modernize your business processes and technology stack for improved efficiency and scalability",
      features: ["Process Automation", "Legacy System Updates", "Cloud Migration", "Workflow Optimization", "Digital Strategy"],
      icon: "🚀"
    },
    {
      title: "Full-Stack Web Solutions",
      description: "Complete web presence development from front-end design to back-end infrastructure",
      features: ["React/Next.js Applications", "Node.js Backends", "E-commerce Platforms", "Progressive Web Apps", "Real-time Features"],
      icon: "🌐"
    },
    {
      title: "Technical Strategy & Consulting",
      description: "Expert guidance to align technology with business objectives and drive growth",
      features: ["Technology Roadmaps", "Architecture Planning", "Team Building", "Project Management", "Technical Audits"],
      icon: "🎯"
    },
    {
      title: "UI/UX & Digital Experience",
      description: "Create intuitive, engaging user experiences that drive conversion and satisfaction",
      features: ["User Research", "Wireframing & Prototyping", "Accessibility Compliance", "Performance Optimization", "A/B Testing"],
      icon: "🎨"
    },
    {
      title: "Content Management & Marketing",
      description: "Comprehensive digital presence management and optimization solutions",
      features: ["WordPress/Drupal Development", "Headless CMS", "SEO Strategy", "Analytics Implementation", "Content Migration"],
      icon: "📈"
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="services-header">
          <div className="logo-branding">
            <div className="logo-container">
              <img
                src={logo2}
                alt="Jaz Smith Digital Services"
                className="services-logo"
              />
            </div>
            <div className="logo-text">
              <h2>JAZ SMITH</h2>
              <h3>DIGITAL SERVICES</h3>
            </div>
            <div className="logo-divider"></div>
          </div>
          <p className="services-intro">
            Comprehensive digital solutions that transform your business challenges into opportunities.
            From strategic planning to technical execution, I deliver innovative solutions that drive growth and efficiency.
          </p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h4>{service.title}</h4>
              <p>{service.description}</p>
              <div className="features-list">
                <h5>Capabilities Include:</h5>
                <ul>
                  {service.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="cta-section">
          <div className="cta-logo">
            <img
              src={logo2}
              alt="Jaz Smith Digital Services"
              className="cta-logo-image"
            />
          </div>
          <h3>Ready to Transform Your Business?</h3>
          <p>Let's discuss how strategic technology solutions can drive your success</p>
          <div className="cta-buttons">
            <a href="#contact" className="cta-primary">Start a Conversation</a>
            {/* <a href="#projects" className="cta-secondary">See Projects</a> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;